import queryString from 'query-string';

export default class PaginationUrlBuilder {
  url;
  pagination;
  sort;
  filters;

  constructor(url, pagination, sort, filters) {
    this.url = url;
    this.pagination = pagination;
    this.sort = sort;
    this.filters = filters;
  }

  createUrl() {
    return `${this.url}?${this.createParamsString()}`;
  }

  createParamsString() {
    const params = this.createParams();

    return queryString.stringify(params);
  }

  createParams() {

    let params = {
      page: this.pagination.currentPage,
      per_page: this.pagination.perPage,
      sort_by: this.sort.by ? this.sort.by : 'id',
      sort_desc: this.sort.desc ? 1 : 0
    };

    for (let index in this.filters) {
      params[index] = this.filters[index];
    }

    return params;
  }

}
